import { useEffect } from 'react';
import { Navigate, useNavigate, useRoutes } from 'react-router-dom';
import SimpleLayout from './layouts/simple';
import AdminLayout from './layouts/admin';
import Login from './pages/Login';
import Page404 from './pages/Page404';
import Dashboard from './pages/Dashboard';
import Airports from './pages/Airports/Airports';
import AddEditAirport from './pages/Airports/AddEditAirport';
import Offers from './pages/Offers/Offers';
import AddEditOffer from './pages/Offers/AddEditOffer';
import Tasks from './pages/Tasks/Tasks';
import AddEditTask from './pages/Tasks/AddEditTask';
import AirportDetails from './pages/AirportDetails/AirportDetails';
import Profile from './pages/Profile';
import TrackByAirport from './pages/TrackByAirport/TrackByAirport';
import Handrail from './pages/Handrail/Handrail';
import Awhm from './pages/AWHM-ABM/Awhm/Awhm';
import Users from './pages/Users/Users';
import AddEditUser from './pages/Users/AddEditUser';
import AddEditHandrail from './pages/Handrail/AddEditHandrail';
import AddEditAwhm from './pages/AWHM-ABM/Awhm/AddEditAwhm';
import config from './config';
import DocumentationBteeSa from './pages/DocumentationBteeSa/DocumentationBteeSa';
import AddEditDocumentationBteeSa from './pages/DocumentationBteeSa/AddEditDocumentationBteeSa';
import Airtrace from './pages/Airtrace/Airtrace';
import AddEditTrainee from './pages/Airtrace/Trainees/AddEditTrainee';
import AddEditCourse from './pages/Airtrace/Courses/AddEditCourse';
import AddEditAirTraceOffer from './pages/Airtrace/Offers/AddEditAirTraceOffer';
import AddEditTraining from './pages/Airtrace/Trainings/AddEditTraining';
import AddEditAbm from './pages/AWHM-ABM/ABM/AddEditAbm';
import AwhmAbm from './pages/AWHM-ABM/AWHM-ABM';
import Settings from './pages/Settings/Settings';
import AddEditContactRoles from './pages/Settings/ContactRoles/AddEditContactRoles';
import AddEditTypeOfCertificate from './pages/Settings/TypeOfCertificates/AddEditTypeOfCertificate';
import i18n from './i18n';
import TitleWrapper from './layouts/admin/header/TitleWrapper';
export default function Router() {
  let role = localStorage.getItem('role');
  
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(config.tokenKey);
    if (!token || token === "" || token == "undefined") {
      localStorage.clear();
      navigate('/login');
    } 
  }, [navigate]);
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/dashboard/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("welcome")}>
              <Dashboard />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/users',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/users/view" />, index: true },
        { 
          path: 'view', 
          element: ['superadmin', 'admin'].includes(role) ? (
            <TitleWrapper title={i18n.t("users")}>
              <Users />
            </TitleWrapper>
          ) : (
            <Navigate to="/login" />
          )
        },
        { 
          path: 'add', 
          element: ['superadmin', 'admin'].includes(role) ? (
            <TitleWrapper title={i18n.t("user")}>
              <AddEditUser />
            </TitleWrapper>
          ) : (
            <Navigate to="/login" />
          )
        },
        { 
          path: ':user_id', 
          element: ['superadmin', 'admin'].includes(role) ? (
            <TitleWrapper title={i18n.t("user")}>
              <AddEditUser />
            </TitleWrapper>
          ) : (
            <Navigate to="/login" />
          )
        },
      ]
    },
    {
      path: '/airports',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/airports/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("airports")}>
              <Airports />
            </TitleWrapper>
          )
        },
        { 
          path: 'add', 
          element: (
            <TitleWrapper title={i18n.t("airport")}>
              <AddEditAirport />
            </TitleWrapper>
          )
        },
        { 
          path: ':airport_id', 
          element: (
            <TitleWrapper title={i18n.t("airport")}>
              <AddEditAirport />
            </TitleWrapper>
          )
        },
        { 
          path: 'airportDetails/:airport_id', 
          element: (
            <TitleWrapper title={i18n.t("airport_details")}>
              <AirportDetails />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/offers',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/offers/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("complete_dashboard")}>
              <Offers />
            </TitleWrapper>
          )
        },
        { 
          path: 'add', 
          element: (
            <TitleWrapper title={i18n.t("complete_dashboard")}>
              <AddEditOffer />
            </TitleWrapper>
          )
        },
        { 
          path: ':offer_id', 
          element: (
            <TitleWrapper title={i18n.t("complete_dashboard")}>
              <AddEditOffer />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/tasks',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/tasks/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("tasks")}>
              <Tasks />
            </TitleWrapper>
          )
        },
        { 
          path: 'add', 
          element: (
            <TitleWrapper title={i18n.t("task")}>
              <AddEditTask />
            </TitleWrapper>
          )
        },
        { 
          path: ':task_id', 
          element: (
            <TitleWrapper title={i18n.t("task")}>
              <AddEditTask />
            </TitleWrapper>
          )
        },
      ]
    },    
    {
      path: '/handrails',
      element: <AdminLayout />,
      children: [
        { element: <Navigate to="/handrails/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("handrails")}>
              <Handrail />
            </TitleWrapper>
          )
        },
        { 
          path: 'add', 
          element: (
            <TitleWrapper title={i18n.t("handrail")}>
              <AddEditHandrail />
            </TitleWrapper>
          )
        },
        { 
          path: ':handrail_id', 
          element: (
            <TitleWrapper title={i18n.t("handrail")}>
              <AddEditHandrail />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/awhm-awm',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/awhm-awm/view/awhm" />, index: true },
        { 
          path: 'view/:tabId', 
          element: (
            <TitleWrapper title={`${i18n.t("awhm")}/${i18n.t("abm")}`}>
              <AwhmAbm />
            </TitleWrapper>
          )
        },
        { 
          path: 'awhm/add', 
          element: (
            <TitleWrapper title={i18n.t("awhm")}>
              <AddEditAwhm />
            </TitleWrapper>
          )
        },
        { 
          path: 'awhm/:awhm_id', 
          element: (
            <TitleWrapper title={i18n.t("awhm")}>
              <AddEditAwhm />
            </TitleWrapper>
          )
        },
        { 
          path: 'abm/add', 
          element: (
            <TitleWrapper title={i18n.t("abm")}>
              <AddEditAbm />
            </TitleWrapper>
          )
        },
        { 
          path: 'abm/:abm_id', 
          element: (
            <TitleWrapper title={i18n.t("abm")}>
              <AddEditAbm />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/documentation-btee-sa',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/documentation-btee-sa/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("documentation_btee_sa")}>
              <DocumentationBteeSa />
            </TitleWrapper>
          )
        },
        { 
          path: 'add', 
          element: (
            <TitleWrapper title={i18n.t("documentation_btee_sa")}>
              <AddEditDocumentationBteeSa />
            </TitleWrapper>
          )
        },
        { 
          path: ':documentation_id', 
          element: (
            <TitleWrapper title={i18n.t("documentation_btee_sa")}>
              <AddEditDocumentationBteeSa />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/airtrace',
      element: <AdminLayout/>,
      children: [
        { element: <Navigate to="/airtrace/view/trainees" />, index: true },
        { path: 'view/:tabId', element: 
          <TitleWrapper title={i18n.t("airtrace")}>
            <Airtrace />
          </TitleWrapper> },
        { path: 'trainee/add', element: 
          <TitleWrapper title={i18n.t("trainee")}>
            <AddEditTrainee />
          </TitleWrapper>  },
        { path: 'trainee/:trainee_id', element: 
          <TitleWrapper title={i18n.t("trainee")}>
            <AddEditTrainee />
            </TitleWrapper> },
        { path: 'course/add', element: 
        <TitleWrapper title={i18n.t("course")}>
          <AddEditCourse />
          </TitleWrapper> },
        { path: 'course/:course_id', element: 
          <TitleWrapper title={i18n.t("course")}><AddEditCourse /></TitleWrapper> },
        { path: 'training/add', element: 
        <TitleWrapper title={i18n.t("training")}><AddEditTraining /></TitleWrapper> },
        { path: 'training/:training_id', element: 
        <TitleWrapper title={i18n.t("training")}><AddEditTraining /></TitleWrapper> },
        { path: 'air_trace_offer/add', element: 
        <TitleWrapper title={i18n.t("air_trace_offer")}><AddEditAirTraceOffer /></TitleWrapper> },
        { path: 'air_trace_offer/:air_trace_offer_id', element: 
        <TitleWrapper title={i18n.t("air_trace_offer")}><AddEditAirTraceOffer /></TitleWrapper> },
      ]
    },
    {
      path: '/track-by-airport',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/track-by-airport/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("airports")}>
              <TrackByAirport />
            </TitleWrapper>
          )
        },
        { 
          path: 'add', 
          element: (
            <TitleWrapper title={i18n.t("airport")}>
              <AddEditAirport />
            </TitleWrapper>
          )
        },
        { 
          path: ':airport_id', 
          element: (
            <TitleWrapper title={i18n.t("airport")}>
              <AddEditAirport />
            </TitleWrapper>
          )
        },
        { 
          path: 'airportDetails/:airport_id', 
          element: (
            <TitleWrapper title={i18n.t("airport_details")}>
              <AirportDetails />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: '/settings',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/settings/view/type_of_certificates" />, index: true },
        { 
          path: 'view/:tabId', 
          element: (
            <TitleWrapper title={i18n.t("settings")}>
              <Settings />
            </TitleWrapper>
          )
        },
        { 
          path: 'type_of_certificates/add', 
          element: (
            <TitleWrapper title={i18n.t("type_of_certificates")}>
              <AddEditTypeOfCertificate />
            </TitleWrapper>
          )
        },
        { 
          path: 'type_of_certificates/:type_of_certificate_id', 
          element: (
            <TitleWrapper title={i18n.t("type_of_certificates")}>
              <AddEditTypeOfCertificate />
            </TitleWrapper>
          )
        },
        { 
          path: 'contact_roles/add', 
          element: (
            <TitleWrapper title={i18n.t("contact_role")}>
              <AddEditContactRoles />
            </TitleWrapper>
          )
        },
        { 
          path: 'contact_roles/:contact_role_id', 
          element: (
            <TitleWrapper title={i18n.t("contact_role")}>
              <AddEditContactRoles />
            </TitleWrapper>
          )
        },
      ]
    },    
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: '/',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="/dashboard/view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("welcome")}>
              <Dashboard />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      path: 'profile',
      element: <AdminLayout />, 
      children: [
        { element: <Navigate to="view" />, index: true },
        { 
          path: 'view', 
          element: (
            <TitleWrapper title={i18n.t("profile")}>
              <Profile />
            </TitleWrapper>
          )
        },
      ]
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
